import { render, staticRenderFns } from "./ManagePartner.vue?vue&type=template&id=765707b8&scoped=true&"
import script from "./ManagePartner.vue?vue&type=script&lang=js&"
export * from "./ManagePartner.vue?vue&type=script&lang=js&"
import style0 from "./ManagePartner.vue?vue&type=style&index=0&id=765707b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765707b8",
  null
  
)

export default component.exports